import React, { useEffect } from 'react';
import setPageMeta from '../../utils/setPageMeta';
import { PAGES } from '../../seo/site';
import CircuitBackground from './components/CircuitBackground';
import MainframeNavbar from './components/MainframeNavbar';
import MainframeHero from './components/MainframeHero';
import MainframeIndustriesSection from './components/MainframeIndustriesSection';
import MainframeServicesSection from './components/MainframeServicesSection';
import MainframeStackSection from './components/MainframeStackSection';
import MainframeBenefitsSection from './components/MainframeBenefitsSection';
import MainframeFooter from './components/MainframeFooter';

const CorporateLandingPage = () => {
  useEffect(() => {
    setPageMeta(PAGES.home);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-black overflow-x-hidden" style={{ fontFamily: 'var(--font-body)' }}>
      <CircuitBackground />
      <MainframeNavbar />
      <MainframeHero />
      <MainframeIndustriesSection />
      <MainframeServicesSection />
      <MainframeStackSection />
      <MainframeBenefitsSection />
      <MainframeFooter />
    </div>
  );
};

export default CorporateLandingPage;
